<template>
  <div>
    <h3>{{$t('strPrivacy')}}</h3>

    <p>Bei der Nutzung des Online-Shops werden verschiedene Daten erhoben. Wir nehmen den Schutz Ihrer Daten sehr ernst und informieren Sie daher nachfolgend über den Umfang und Zweck der Datenverarbeitung.</p>

    <ol style="    list-style-type: upper-roman;">
      <li>
        <sui-list-content>
          <strong>Verantwortlicher</strong>
          <sui-list-description>

            Als Betreiberin des Shops ist verantwortlich:<br />
            LAN1 Hotspots GmbH (nachfolgend "LAN1")<br />
            Gau&szlig;stra&szlig;e 158<br />
            22765 Hamburg<br />
            E-Mail: info@lan1.de<br />
            Tel.: 040 317 6666 66<br />
            Impressum: https://www.lan1.de/impressum<br />
            <br />
          </sui-list-description>
        </sui-list-content>
      </li>

      <li>
        <sui-list-content>
          <strong>Fragen zum Datenschutz</strong>
          <sui-list-description>

            Bei Fragen zum Datenschutz k&ouml;nnen Sie sich jederzeit wenden an<br />
            Herrn J&ouml;rg H&uuml;mmer<br />
            LAN1 Hotspots GmbH<br />
            E-Mail: datenschutz@lan1.de<br />
            Tel.: 040 317 6666 16<br />
            <br />
          </sui-list-description>
        </sui-list-content>
      </li>

      <li>
        <sui-list-content>
          <strong>Umfang und Rechtsgrundlage der Datenerhebung</strong>
          <sui-list-description>

            <ol style="list-style-type: decimal-leading-zero;">
              <li>
                <sui-list-content>
                  LAN1 erhebt und verwendet Daten, die f&uuml;r Abwicklung Ihres Kaufes also zur Vertragsdurchf&uuml;hrung. Rechtsgrundlage f&uuml;r diese Datenverarbeitung ist Art. 6 Abs. 1 lit. b DSGVO. Zudem erhebt und verwendet LAN1 Daten zur Verbesserung der eigenen Dienste und f&uuml;r statistischen Zwecke. Dies erfolgt aufgrund berechtigen Interesses auf der Rechtsgrundlage des Art. 6 Abs. 1 lit. f DSGVO.
                </sui-list-content>
              </li>
              <li>
                <sui-list-content>
                  Im Einzelnen erheben wir folgende Daten:
                  <ul>
                    <li> Ihre E-Mail-Adresse, sofern Sie Ihren erworbenen Voucher per E-Mail erhalten m&ouml;chten.</li>
                    <li>Ihre Handynummer, sofern Sie Ihren erworbenen Voucher per SMS erhalten m&ouml;chten.</li>
                    <li>Daten die Google Analytics zur Analyse und Verbesserung unseres Dienstes f&uuml;r LAN1 erhebt.</li>
                  </ul>
                  Ihre E-Mail-Adresse und/oder Ihre Handynummer dient ausschlie&szlig;lich der &Uuml;bermittlung des Vouchers. Zudem &uuml;berpr&uuml;fen wir, ob Sie den Voucher erhalten haben. Eine sonstige Verwendung oder Weitergabe der Daten erfolgt nicht.
                </sui-list-content>
              </li>
              <li>
                <sui-list-content>
                  F&uuml;r die Zahlungsabwicklung arbeiten wir mit dem Zahlungsdienstleister SIX Payment Services AG zusammen (s. hierzu ausf&uuml;hrlich unter V.). Dort werden im Zuge der Bezahlung Ihres Kaufes die von Ihnen gemachten Angaben &uuml;ber Zahlungs- und Rechnungsdaten direkt bei SIX Payment gespeichert und f&uuml;r den Zahlungsvorgang verarbeitet. LAN1 hat Zugriff auf die dort gespeicherten Daten.<br />
                  Sie k&ouml;nnen beim Kauf selbst entscheiden, welche Daten Sie angeben m&ouml;chten. Ist beispielsweise eine f&uuml;r den Umsatzsteuerabzug berechtigte Rechnung erw&uuml;nscht, k&ouml;nnen Sie die daf&uuml;r erforderlichen Daten angeben. Im Einzelnen k&ouml;nnen entsprechend Ihrer Wahl folgende Angaben erhoben und gespeichert werden:<br />
                  Ihre Kundenadresse (Anrede, Vor-/Nachname, Stra&szlig;e, PLZ, Ort, Land, E-Mail-Adresse und Telefonnummer) und Ihre Zahlungsdaten (wahlweise Mastercard, Visa, Bezahlen per Online Banking (Klarna), Paypal oder Masterpass by Mastercard).<br />
                </sui-list-content>
              </li>
            </ol>
            <br /><br />
          </sui-list-description>
        </sui-list-content>
      </li>


      <li>
        <sui-list-content>
          <strong>Verwendung und L&ouml;schung der Daten</strong>
          <sui-list-description>

            Die Daten werden ausschlie&szlig;lich f&uuml;r die Abwicklung des Bestellvorganges verwendet. Sie werden entsprechend der gesetzlichen Aufbewahrungsfrist des Finanzamtes f&uuml;r 10 Jahre gespeichert und dann im Regelfall gem. Art. 17 DSGVO gel&ouml;scht, da der Zweck der Speicherung entfallen ist. Davon ausgenommen sind Daten, die gem&auml;&szlig; den gesetzlichen Bestimmungen zwingend vorher gel&ouml;scht werden m&uuml;ssen.<br />
            Ausnahmsweise werden die Daten nicht gel&ouml;scht, wenn gesetzliche Vorgaben oder sonstige Bestimmung dem entgegenstehen.<br />
            <br />
          </sui-list-description>
        </sui-list-content>
      </li>

      <li>
        <sui-list-content>
          <strong>Drittanbieter</strong>
          <sui-list-description>
            LAN1 arbeitet zur Bereitstellung des Shops mit Dienstleistern zusammen, die Daten f&uuml;r LAN1 verarbeiten. Dies geschieht innerhalb der gesetzlichen Regelung des Art. 28 DSGVO und nur im Rahmen der Weisung von LAN1. Alle Auftragsverarbeiter wurden gem&auml;&szlig; den gesetzlichen Bestimmungen sorgf&auml;ltig ausgew&auml;hlt und erhalten nur Zugriff auf die zur Erbringung der Dienstleistung erforderlichen Daten.<br />
            Die spezifischen unter III. (3) genannten Daten werden von Saferpay, einem Tool des Zahlungsdienstleisters SIX Payment Services AG (Hardturmstra&szlig;e 201, CH-8005 Z&uuml;rich) erhoben.<br />
            SIX setzt h&ouml;chste Anforderungen an Daten- und Prozesssicherheit und zertifiziert seine Produkte mit PCI DSS.<br />
            Weitere Informationen zum Schutz von Daten bei SIX erhalten Sie auf der Website:<br />
            <a href="https://www.six-payment-services.com/de/site/e-commerce/support/faq.html#security" target="_blank">https://www.six-payment-services.com/de/site/e-commerce/support/faq.html#security</a><br /><br />
            Bei der Benutzung des Shops werden mit Ihrem Einverst&auml;ndnis Daten von Google-Analytics erhoben. Google ist nach dem Privacy-Shield-Abkommen zertifiziert, wodurch die Einhaltung des europ&auml;ischen Datenschutzrechts gew&auml;hrleistet wird.<br />
            Google Analytics verwendet sog. 'Cookies', die auf ihrem Endger&auml;t gespeichert werden und die eine Analyse der Benutzung erm&ouml;glicht, vgl. unter VI. Cookies. Sie k&ouml;nnen der Speicherung der Cookies verhindern, indem sie beim Aufruf der Seite bei der Cookie Auswahl 'Statistiken' abw&auml;hlen. Auch eine nachtr&auml;gliche Abwahl ist m&ouml;glich.<br />
            Dar&uuml;ber hinaus k&ouml;nnen Sie entsprechende Einstellungen in Ihrem Browser vornehmen oder das unter dem folgenden Link verf&uuml;gbare Browser-Plugin installieren: <a href="https://tools.google.com/dlpage/gaoptout?hl=de" target="_blank">https://tools.google.com/dlpage/gaoptout?hl=de</a>.<br /><br />
            Die von uns an Google gesendeten Daten werden gem&auml;&szlig; unseren Einstellungen nach 14 Monaten gel&ouml;scht.<br />
            Weitere Informationen zur Datenerhebung und -verarbeitung sowie zu Ihren Einstellungs- und Widerspruchsm&ouml;glichkeiten finden Sie auf der Website von Google:<br />
            <a href="https://policies.google.com/technologies/partner-sites?hl=de" target="_blank">https://policies.google.com/technologies/partner-sites?hl=de</a> und <a href="https://policies.google.com" target="_blank">https://policies.google.com.</a>
            <br /><br />

          </sui-list-description>
        </sui-list-content>
      </li>

      <li>
        <sui-list-content>
          <strong>Cookies</strong>
          <sui-list-description>
            Wir setzen auf unserer Seite Cookies ein. Cookies sind kleine Dateien, die es erm&ouml;glichen, auf dem Zugriffsger&auml;t der Nutzer (PC, Smartphone o.&auml;.) spezifische, auf das Ger&auml;t bezogene Informationen zu speichern. Sie dienen der Benutzerfreundlichkeit von Webseiten (z.B. Speicherung von Logindaten) und der Analyse der Website. Sie k&ouml;nnen auf den Einsatz der Cookies durch Einstellungen in Ihrem Browser oder durch Auswahl &uuml;ber die folgende Schaltfl&auml;che Einfluss nehmen. Allerdings wird darauf hingewiesen, dass die Nutzung eingeschr&auml;nkt werden kann.<br />
            <sui-button @click="clickCookie">Cookies Anpassen</sui-button>
            <br /><br />
          </sui-list-description>
        </sui-list-content>
      </li>


      <li>
        <sui-list-content>
          <strong>Ihre Rechte</strong>
          <sui-list-description>
            Gem&auml;&szlig; der DSGVO informieren wir Sie an dieser Stelle &uuml;ber Ihre Rechte als Betroffener der Verarbeitung personenbezogener Daten.
            Gem. Art. 15 DSGVO haben Sie ein Auskunftsrecht &uuml;ber die von Ihnen bei uns gespeicherten Daten.
            Nach Art. 16 DSGVO haben Sie das Recht unvollst&auml;ndige oder falsche Daten berichtigen zu lassen.
            Sie k&ouml;nnen zudem nach Ma&szlig;gabe des Art. 17 DSGVO verlangen, dass LAN1 entsprechende Daten l&ouml;scht, bzw. ggf. nach Art. 18 DSGVO die Verarbeitung einschr&auml;nkt.
            Ihre Daten k&ouml;nnen Sie nach Art. 20 DSGVO in einem maschinenlesbaren Format erhalten oder die &Uuml;bermittlung an einen anderen Anbieter fordern.
            Abschlie&szlig;end haben Sie gem. Art. 77 DSGVO ein Beschwerderecht bei der zust&auml;ndigen Aufsichtsbeh&ouml;rde.
            <br /><br />
          </sui-list-description>
        </sui-list-content>
      </li>


    </ol>


  </div>
</template>

<script>
  export default {
    methods: {
      clickCookie() {
        localStorage.removeItem('cookies:accepted');
        location.reload();
      }
    }
  }
</script>

<style>

</style>
